<div class="header" (click)="onCollapsibleClick()">
    <div class="title">
        {{ title$ | async }}
    </div>
    <mat-icon
        class="text-primary shrink-0"
        svgIcon="chevron-up"
        [@flipIcon]="collapsed$ | async"
    ></mat-icon>
</div>

@if ((collapsed$ | async) === false) {
    <div class="content" (click)="onCollapsibleClick($event)">
        <ng-content></ng-content>
    </div>
}
